import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DataList } from "@/common/DataList";
import type { GeneralInfoTabFormValues } from "@/entities/general-info-tab-content/model";
import { PhoneField } from "./PhoneField";

type Props = {
  personId: string;
  isEditMode: boolean;
  handleEditMode: () => void;
  onSubmit: (data: GeneralInfoTabFormValues) => void;
  disabled?: boolean;
};

export const PhonesList = ({ personId, isEditMode, handleEditMode, onSubmit, disabled }: Props) => {
  const { t } = useTranslation();

  const { control, getValues, trigger } = useFormContext<GeneralInfoTabFormValues>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "phones",
  });

  const onBlur = async () => {
    const isValid = await trigger("phones");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  const onChange = () => {
    trigger("phones");
  };

  const addHandler = () => {
    if (!isEditMode) {
      handleEditMode();
    }

    setTimeout(() => {
      append({ phoneType: { name: "" }, number: "", id: undefined, personId });
      // trigger("phones");
    }, 0);
  };

  const removeHandler = async (index: number) => {
    remove(index);

    const isValid = await trigger("phones");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  return (
    <DataList
      data={fields.map((field) => ({
        id: field.id,
        label: field.phoneType?.name ?? "",
        value: field.number ?? "",
      }))}
      onAddClick={addHandler}
      onTrashClick={removeHandler}
      isEdit={isEditMode}
      title={t("contactsPage.generalInfo.phones")}
      editNode={(index) => <PhoneField index={index} onBlur={onBlur} onChange={onChange} />}
      disabled={disabled}
    />
  );
};
